module.exports = __webpack_public_path__ + "static/fish_fr-0c5709f26f3754b4e3ff296186c90f4d.jpg";